/**
 * Modèle des paramètres des passwords
 */
export class PasswordParams {
    /** Id */
    id: number;

    /** Type de connexion */
    loginType: LoginType;

    /** Longueur minimale du mot de passe */
    minLength: number;

    /** Nombre minimal de majuscules du mot de passe */
    minMajuscule: number;

    /** Nombre minimal de minuscules du mot de passe */
    minMinuscule: number;

    /** Nombre minimal de chiffes du mot de passe */
    minChiffre: number;

    /** Nombre minimal de caractères spéciaux du mot de passe */
    minSpecial: number;

    /** Nombre de mots de passe historisés */
    historique: number;

    /** Nombre de jours avant péremption automatique du mot de passe */
    peremptionNbJour: number;

    /** Nombre de tentatives possibles avant blocage du compte */
    tentativeNb: number;

    /** Nom de la configuration de mots de passe */
    nom: string;

    /** Activation du reCAPTCHA */
    recaptchaActif: boolean;
}

/** Enumération des types de login */
export enum LoginType {
    LOCAL = "LOCAL",
    SAML = "SAML",
}